import { EnsureStylesheetLoaded } from '@eurotunnel-pax/leshuttle.ui/src/scripts/utilities/EnsureStylesheetLoaded'
import { setupLoader } from '../../utilities/IntersectionAnimator'

const ignoredClasses = ['offcanvas']

function performLoad (sections, isSS) {
  for (const section of sections) {
    section.classList.remove('loading')

    let isAllowed = true

    for (const cls of ignoredClasses) {
      if (section.classList.contains(cls)) {
        isAllowed = false
      }
    }

    if (isAllowed && isSS === false && !section.dataset.instant) {
      section.classList.add('animate-in')
      setupLoader(section)
    }
  }
}

export function loadSections (elem) {
  if (!elem) {
    elem = document
  }
  const sections = elem.querySelectorAll('.loading')

  const urlParams = new URLSearchParams(window.location.search)
  const ss = urlParams.has('ss')

  if (ss) {
    performLoad(sections, true)
    return
  }

  return EnsureStylesheetLoaded().then(function () {
    performLoad(sections, false)
  })
}
